import styled, { css } from 'styled-components';
import { Block } from './Block';
import { Container } from './Container';
import { padding, space } from './helpers';

export const Layer = styled.div<{
  _space?: number;
  _offsetTop?: number;
  _right?: boolean;
}>`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: ${({ _space }) => padding(_space)}px;

  pointer-events: none;
  & > * {
    pointer-events: all;
  }

  & ${Block} {
    border-radius: 0 !important;
    overflow: visible !important;
  }

  ${({ _offsetTop }) =>
    _offsetTop &&
    css`
      top: ${_offsetTop}px;
    `}

  ${({ _right }) =>
    _right &&
    css`
      align-items: flex-end;
    `}

  ${({ _space }) =>
    _space &&
    css`
      padding: ${space(_space)}px !important;
    `}
`;

export const HiddenLayer = styled(Layer)<{
  _withAnimation?: boolean;
  _isOverlayShown?: boolean;
}>`
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease;
  transition-property: transform, visibility, opacity;

  ${({ _withAnimation }) =>
    _withAnimation &&
    css`
      transform: translate(0, 10px);
    `}

  ${({ _isOverlayShown }) =>
    _isOverlayShown &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translate(0, 0);
    `};

  ${Container}:focus &, ${Container}:hover & {
    opacity: 1;
    visibility: visible;
    transform: translate(0, 0);
  }
`;
